import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface PerformanceRow {
  readonly performanceId: string;
  readonly metricType: string;
  readonly sourceLabel: string;
  readonly metricValue: string;
  readonly unit: string;
  readonly status: string;
  readonly thresholdBreached: boolean;
}

export function M19PerformanceDashboardPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<PerformanceRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: PerformanceRow[] }>('/v1/platform/performance', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m19.performance.loading')}</p>;
  return (
    <main aria-label="performance-dashboard">
      <h1>{t('m19.performance.title')}</h1>
      <table aria-label="performance-table">
        <thead><tr><th>{t('m19.performance.colMetric')}</th><th>{t('m19.performance.colSource')}</th><th>{t('m19.performance.colValue')}</th><th>{t('m19.performance.colStatus')}</th><th>{t('m19.performance.colBreached')}</th></tr></thead>
        <tbody>
          {rows.map((p) => (
            <tr key={p.performanceId}>
              <td>{p.metricType}</td>
              <td>{p.sourceLabel}</td>
              <td>{p.metricValue} {p.unit}</td>
              <td>{p.status}</td>
              <td>{p.thresholdBreached ? t('m19.performance.yes') : t('m19.performance.no')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
